export default __webpack_public_path__ + "ebfc8acf2f5bcb8c693d5015f2505858.png";